import { API_INSTANCE, buildURLWithState } from 'src/features/utils';
import type {
  HostOrganization,
  OrganizationStatus,
  OrganizationMember,
  CreateOrganizationPayload,
  UpdateOrganizationPayload,
  InviteMemberPayload,
} from './types';

export const checkOrganizationStatusApi = async (state: any) => {
  return await API_INSTANCE.get<OrganizationStatus>(
    buildURLWithState(state, `/api/v1/dashboard/host-organizations/check`),
  );
};

export const fetchMyOrganizationApi = async (state: any) => {
  return await API_INSTANCE.get<HostOrganization>(
    buildURLWithState(state, `/api/v1/dashboard/host-organizations/my-organization`),
  );
};

export const createOrganizationApi = async (state: any, payload: CreateOrganizationPayload) => {
  const url = buildURLWithState(state, `/api/v1/dashboard/host-organizations`);

  // Always use JSON - backend supports it
  return await API_INSTANCE.post<HostOrganization>(url, payload);
};

export const updateOrganizationApi = async (
  state: any,
  organizationId: string,
  payload: UpdateOrganizationPayload,
) => {
  const url = buildURLWithState(state, `/api/v1/dashboard/host-organizations/${organizationId}`);

  // Always use JSON - backend supports it
  return await API_INSTANCE.put<HostOrganization>(url, payload);
};

export const fetchMembersApi = async (state: any, organizationId: string, status?: string) => {
  const url = buildURLWithState(
    state,
    `/api/v1/dashboard/host-organizations/${organizationId}/members`,
  );
  const params = status ? { status } : {};
  return await API_INSTANCE.get<OrganizationMember[]>(url, { params });
};

export const inviteMemberApi = async (
  state: any,
  organizationId: string,
  payload: InviteMemberPayload,
) => {
  return await API_INSTANCE.post<OrganizationMember>(
    buildURLWithState(state, `/api/v1/dashboard/host-organizations/${organizationId}/members`),
    payload,
  );
};

export const removeMemberApi = async (state: any, organizationId: string, memberId: string) => {
  return await API_INSTANCE.delete(
    buildURLWithState(
      state,
      `/api/v1/dashboard/host-organizations/${organizationId}/members/${memberId}`,
    ),
  );
};

export const resendInvitationApi = async (state: any, organizationId: string, memberId: string) => {
  return await API_INSTANCE.post(
    buildURLWithState(
      state,
      `/api/v1/dashboard/host-organizations/${organizationId}/members/${memberId}/resend-invitation`,
    ),
  );
};

export const deletePendingInvitationApi = async (
  state: any,
  organizationId: string,
  invitationId: string,
) => {
  return await API_INSTANCE.delete(
    buildURLWithState(
      state,
      `/api/v1/dashboard/host-organizations/${organizationId}/invitations/${invitationId}`,
    ),
  );
};
